import React from 'react'

const UserInfo = ({ auth }) => <span>{auth.user.name || '-'}</span>

export default UserInfo
